//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../../assets/css/view.css'
import comicobject from '../script/comicobject'
import buy_item from './items/buy'
import Vue from "vue";

export default ({
  name: 'index',
  mixins: [comicobject],
  components: {buy_item},
  data() {
    return {
      drawerRight: true,
      bottomNav: {},
      expand: false,
      comin_data_error_mark: false,
      breadcrumbs_items: [],
      current_photo_list: undefined,
      chapter_list: [],
      last_chapter: undefined,
      current_chapter: undefined,
      chapter_list_dialog: false,
      star_loading: false,
      comic_data: undefined,
      tabinfo: {
        comic_buy: {
          chapter_list: []
        }
      },
      buy_chapter: {}
    }
  },
  computed: {
    total_chapter: function () {
      return this.compute_total_chapter(this.comic_data).length;
    },
    is_loading: function () {
      return !this.comic_data;
    }
  },
  created() {
    window._t = this;
    console.log('this.$route.params.id:', this.$route.params.id);
    this.update_current_chapter();
    this.load_comic_data({id: this.$route.params.id, watch_chapter: this.current_chapter, tabinfo: true});
    if (this.$store.state.hasLogin) {
      this.load_tabinfo(this.$route.params.id);
    }
    this.$app.footer(false);
  },
  watch: {
    '$route'(to, from) {
      console.log("to:", to, "from:", from);
      this.update_current_chapter();
      this.load_comic_data({id: this.$route.params.id, watch_chapter: this.current_chapter});
    },
    "tabinfo.comic_buy": {
      handler(new_value, old_value) {
        console.log("tabinfo.comic_buy change:", new_value, old_value);
        Vue.nextTick(() => {
          this.update_need_buy();
          this.$forceUpdate();
        });
      },
      immediate: true,
      deep: true
    },
  },

  methods: {
    update_current_chapter: function () {
      var urlvars = this.getUrlVars();
      if (urlvars) {
        this.current_chapter = urlvars.c;
      }
      this.current_chapter = parseInt(this.current_chapter);
      if (isNaN(this.current_chapter)) {
        this.current_chapter = 1;
      }
    },
    star_click: function () {
      if (!this.$store.state.hasLogin) {
        return this.$app._userbar.show_login_dialog();
      }
      this.star_loading = true;
      var post_data = {
        'id': this.comic_data.id,
        'action': !this.tabinfo.isstar
      };
      this.$axios.post('/app/comic/star', post_data).then((response) => {
        this.star_loading = false;
        var response_data = response.data;
        console.log("response_data:", response_data)
        this.tabinfo.isstar = !this.tabinfo.isstar;
      }).catch((error) => {
        console.log('error:', error);
        this.star_loading = false;
      });
    },
    show_chpter_list: function () {

    },
    on_chapter_select: function (select_chapter) {
      console.log("on_chpter_select:", select_chapter);
      var go_url = this.updateQueryStringParameter(location.pathname, 'c', select_chapter);
      this.$router.push(go_url);
    },
    next_chapter: function () {
      this.on_chapter_select(this.current_chapter + 1)
    },
    pre_chapter: function () {
      this.on_chapter_select(this.current_chapter - 1)
    },
    on_comic_data_change: function (comic_data) {

      console.log('on_comin_data_change:', comic_data);
      this.comic_data = comic_data;
      var current_photo_list = this.comic_data.photo_object[(this.current_chapter - 1) + ""];
      if (current_photo_list.length <= 0) {

      }

      this.current_photo_list = []

      var space_name = this.comic_data.photo_object.space_name;
      for (var i = 0; i < current_photo_list.length; ++i) {
        var compic_url = this.generate_compic_url(space_name, this.comic_data.id, this.current_chapter - 1, current_photo_list[i]);
        this.current_photo_list.push(compic_url);
      }

      var comic_title = this.comic_data.title + " " + "第" + (parseInt(this.current_chapter)) + "话";

      this.breadcrumbs_items = []
      this.breadcrumbs_items.push({
        text: this.comic_data.title,
        href: "/comic/" + this.comic_data.id
      });

      var ptitle = '';
      var photo_title = this.comic_data.photo_title;
      if (photo_title && photo_title[this.current_chapter + ""]) {
        ptitle = photo_title[this.current_chapter + ""];
      }

      this.breadcrumbs_items.push({
        text: "第" + (parseInt(this.current_chapter)) + "话" + " " + ptitle,
        href: "/view/" + this.comic_data.id + "?c=" + this.current_chapter
      });

      this.set_title(comic_title)

      this.chapter_list = this.generate_chapter_list(this.comic_data);
      console.log("this.chapter_list:", this.chapter_list);

      this.last_chapter = this.chapter_list.length;
      console.log("last_chapter:", this.last_chapter, ' this.current_chapter:', this.current_chapter)
      this.update_need_buy();
    },
    on_comin_data_error: function (id, error) {
      this.comin_data_error_mark = true;
    },
    on_tabinfo_change: function (tabinfo) {
      this.tabinfo = tabinfo;
      this.tabinfo.watch_chapter = this.current_chapter;
      this.update_need_buy();
      this.$forceUpdate();
    },
    on_compic_error: function (e) {
      console.log("on_compic_error:", e);
    },
    update_need_buy: function () {
      var comic_buy = this.tabinfo.comic_buy;
      if (comic_buy) {
        if (Array.isArray(comic_buy.chapter_list) && comic_buy.chapter_list.indexOf(this.current_chapter) >= 0) {
          console.log('已购买comic_buy:', comic_buy)
          this.buy_chapter.is_need_buy = false;
          return;
        }
      }
      if (this.comic_data) {
        var is_need_buy = this.is_need_buy(this.comic_data, this.current_chapter);
        if (is_need_buy) {
          this.buy_chapter.is_need_buy = true;
        }
      }
    }
  }
})
